import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'vc-condition-guide',
  templateUrl: './condition-guide.component.html',
  styleUrls: ['./condition-guide.component.scss']
})
export class ConditionGuideComponent implements OnInit {
  public displayRefusalReason: boolean; // to display bloc if there is content
  public showRefusalReason: boolean; // to toogle show/hide block with button

  @Input()
  conditionName: string;
  @Input()
  goodCondition: string;
  @Input()
  badCondition: string;
  @Input()
  id: number;

  constructor() {}

  ngOnInit() {
    this.showRefusalReason = false;
    this.displayRefusalReason = !(this.badCondition === '');
  }

  toggleRefusalReason() {
    this.showRefusalReason = !this.showRefusalReason;
  }
}
